<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin: 10px;">
        <div class="head-block-title">
            <div class="row">
                <div class="col-md-8">
                    <span class="listHeaderText">Allotment List ({{allotmentListData?.length}})</span>
                </div>
                <div class="col-md-4 d-flex" style="justify-content: flex-end;">
                    <div class="d-flex" data-toggle="modal" data-target="#bookingModalRight" (click)="changeAddUpdateModalState()">
                        <div class="add-actionbutton-icon">
                            <img src="assets/images/addbookingwhite.svg" aria-hidden="true">
                        </div>
                        <div class="add-actionbutton-text ">Add</div>
                    </div>
                    &nbsp; &nbsp;
                    <export  [showIconOnly]="false" [data]="selectedExportData"></export>
                </div>

            </div>
        </div>
        <div class="main-field">
            <div class="main-block-content">
                <div style="height: 500px; margin: 10px;">
                    <app-common-table [columnDefs]="columnDefs" [data]="allotmentListData"
                        (commonDropdownChange)="onCommonTableDropdownChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)">
                    </app-common-table>
                </div>

            </div>
        </div>
    </div>
</div>



<!--Booking Mobile view-->
<div class="content-area">
    <span class="listHeaderText">Allotment List ({{allotmentListData?.length}})</span>
    <div class="row subHeaderButtonDiv">
        <div class="col-md-6 export-div">
            <div class="dropdownMenu d-flex mt-1">
                <div class="export-actionbutton-icon">
                    <img src="../../../../assets/images/exportwhite.svg">
                </div>
                    <span class="add-actionbutton-text dropdown-toggle"> Export</span>

                <ul class="dropdownMenu-content" style="text-align:center;top: 37px;">
                    <button type="button" class="btn" data-toggle="modal" data-target=".export-modal"><span
                            class="dropdownMenu-content-option"><a
                                (click)="toggleExport('excel')">Excel</a></span></button>
                    <button type="button" class="btn d-flex" style="position: relative;padding-left: 35px;"
                        data-toggle="modal" data-target=".export-modal"><span class="dropdownMenu-content-option"><a
                                (click)="toggleExport('pdf')">PDF</a></span></button>
                </ul>
            </div>
        </div>
        <div class="col-md-6 d-flex" class="positioned-flex">
            <div class="closeModal" (click)="changeAddUpdateModalState()">
                <span class="add-actionbutton-icon"> <img src="../../../../assets/images/addbookingwhite.svg"
                        aria-hidden="true"></span>
                <span class="add-actionbutton-text"> Add</span>
            </div>
        </div>
    </div>
    <div class="modal export-modal" [ngClass]="showExport ? 'booking-modal-show fade':'booking-modal-hide'"
        tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <app-export-list (exportValues)="exportValues($event)" (hideModal)="hideExport()"
                    [exportType]="exportSelectedType" style="height: 59vh;" [columns]="exportColumns"
                    [submitButtonTitle]="'Export'"  [rowSelection]="'multiple'"
                    [headerName]="'Booking List'"  [fileName]="fileName"
                    [exportColumnKeys]="columnKeys"></app-export-list>
            </div>
        </div>
    </div>
    <div class="searchtext">
        <div class="row">
            <div class="col-md-8">
            </div>
            <div class="col-md-2">
                <span>
                    <input type="search" class="form-control" placeholder="Search Booking" style="height: 33px;"
                        [(ngModel)]="filterTerm" [ngModelOptions]="{standalone: true}">
                </span>
            </div>
        </div>
    </div>
    <div class="row row-cards-one">
        <div class="col-md-12 col-lg-3 col-xl-3">
            <div class="mycard bg1" *ngFor="let item of allotmentListData | filter: filterTerm">
                <div class="left">
                    <tr>
                        <td>
                            <h6>
                                <b><i class="fa fa-user" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{item?.customerName}}</b><br>
                                <b><i class="fa fa-phone" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{item?.contactNumber}}</b><br>
                                <i href="tel:{{item.contactNumber}}"></i>
                                <b><i class="fa fa-inr" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{item?.amount}}</b>
                            </h6>
                        </td>
                    </tr>
                </div>
                <div class="right d-flex align-self-center">
                    <tr>
                        <td>
                            <div class="dropdownMenu" (click)="dropdownActonMenu(item.id)" style="display: block;">
                                <div>
                                  <img src="assets/images/Action icon red.svg" alt="">
                                </div>
                                <div class="dropdownMenu-content dropdownActionMenu" id="actionMenuContent{{item.id}}"
                                  *ngIf="ActionList" style="top: 24px; right: 0vh;">

                                <span class="dropdownMenu-content-option"
                                    (click)="onCommonTableDropdownMobileChange(item,'edit')"><img [src]="editIcon"
                                        alt="Edit Icon" class="icon-img" />Edit</span>
                                <span class="dropdownMenu-content-option"
                                    (click)="onCommonTableDropdownMobileChange(item,'transfer')"><img
                                        [src]="transferIcon" alt="Transfer Icon" class="icon-img" />Transfer</span>
                                <span class="dropdownMenu-content-option"
                                    (click)="onCommonTableDropdownMobileChange(item,'payment')"><img [src]="paymentIcon"
                                        alt="Payment Icon" class="icon-img" />Payment</span>
                                <span class="dropdownMenu-content-option"
                                    (click)="onCommonTableDropdownMobileChange(item,'cancel')"><img [src]="cancelIcon"
                                        alt="Cancel Icon" class="icon-img" />Cancel</span>
                            </div>
                        </div>
                </tr>
            </div>
        </div>
    </div>
</div>
<app-confirmation-dialog
  [data]="dialogData"
  [isVisible]="showDialog"
  (confirmEvent)="onConfirmed($event)">
</app-confirmation-dialog>

